import {UncontrolledTooltip} from 'reactstrap';
import classNames from 'classnames';
import React, {memo, useCallback} from 'react';

const FloatToolbar = memo(({children, show, onClose, position, closeText = 'Cancel', className = ''}) => {
    const handleClose = useCallback(_ => onClose());
    return (
        <div className={classNames(`fixed-${position || 'bottom'} d-flex justify-content-center p-2`, {
            'show-toolbar': show,
            'hide-toolbar': !show,
        })} style={{pointerEvents: 'none'}}>
            <div className={'float-toolbar-horizontal ' + className} style={{pointerEvents: 'visible'}}>
                {children}
                <div className='pl-2 border-left'>
                    <div onClick={handleClose} id={`unselect-button-${closeText}`}>
                        <i className='mdi mdi-close-circle float-toolbar-button cursor-pointer'/>
                    </div>
                    <UncontrolledTooltip placement='top' target={`unselect-button-${closeText}`}>
                        {closeText}
                    </UncontrolledTooltip>
                </div>
            </div>
        </div>
    )
});

export default FloatToolbar;